import Rollbar from 'rollbar'

export const rollbarServerConfig = {
  accessToken: process.env.ROLLBAR_SERVER_TOKEN,
  captureUncaught: true,
  captureUnhandledRejections: true,
  enabled: ['production', 'staging'].includes(
    process.env.NEXT_PUBLIC_RUN_ENV || 'development'
  ),
  environment: process.env.NEXT_PUBLIC_RUN_ENV,
}

const rollbarConfig = {
  scrubFields: ['Authorization'],
  accessToken: process.env.NEXT_PUBLIC_ROLLBAR_CLIENT_TOKEN,
  environment: process.env.NEXT_PUBLIC_RUN_ENV,
  hostSafeList: ['next.farmai.listenfield.com', 'farmai.listenfield.com'],
  enabled: ['production', 'staging'].includes(
    process.env.NEXT_PUBLIC_RUN_ENV || 'development'
  ),
  captureUncaught: true,
  captureUnhandledRejections: true,
  payload: {
    environment: process.env.NEXT_PUBLIC_RUN_ENV,
    client: {
      javascript: {
        source_map_enabled: true,
        code_version: process.env.NEXT_PUBLIC_BUILD_ID,
        guess_uncaught_frames: true,
      },
    },
  },
}

export const rollbarInstance = new Rollbar(rollbarConfig)
